<template>
    <v-dialog v-model="show" max-width="500px" :persistent="loading">
        <v-card class="cotutor-modal">
            <v-card-title class="modal-title">Agregar Co-tutor</v-card-title>
            <v-card-text>
                <v-form ref="form">
                    <div class="field-wrapper">
                        <label class="field-label">Nombre</label>
                        <v-text-field
                            v-model="form.firstName"
                            placeholder="Nombre"
                            outlined
                            dense
                            hide-details="auto"
                            class="custom-input"
                            :rules="[v => !!v || 'El nombre es obligatorio']"
                        />
                    </div>
                    <div class="field-wrapper">
                        <label class="field-label">Apellidos</label>
                        <v-text-field
                            v-model="form.lastName"
                            placeholder="Apellidos"
                            outlined
                            dense
                            hide-details="auto"
                            class="custom-input"
                            :rules="[v => !!v || 'Los apellidos son obligatorios']"
                        />
                    </div>
                    <div class="field-wrapper">
                        <label class="field-label">RUT / DNI <span class="optional">(opcional)</span></label>
                        <v-text-field
                            v-model="form.rut"
                            placeholder="RUT / DNI"
                            outlined
                            dense
                            hide-details="auto"
                            class="custom-input"
                        />
                    </div>
                    <div class="field-wrapper">
                        <label class="field-label">Tipo de relación</label>
                        <v-select
                            v-model="form.relationshipType"
                            :items="relationshipOptions"
                            item-text="label"
                            item-value="value"
                            placeholder="Seleccionar"
                            outlined
                            dense
                            hide-details="auto"
                            class="custom-input"
                            :rules="[v => !!v || 'El tipo de relación es obligatorio']"
                        />
                    </div>
                    <div class="field-wrapper">
                        <label class="field-label">Archivo adjunto <span class="optional">(opcional)</span></label>
                        <v-file-input
                            v-model="form.file"
                            placeholder="Seleccionar archivo"
                            outlined
                            dense
                            hide-details="auto"
                            class="custom-input"
                            accept="image/*,.pdf"
                            prepend-icon="mdi-paperclip"
                        />
                    </div>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="close">Cancelar</v-btn>
                <v-btn color="primary" :loading="loading" @click="save">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Api360Service from '../services/360.service.js';
import { RELATIONSHIP_TYPE_OPTIONS } from '../utils/relationship-type.utils';

export default {
    name: 'AddCoTutorModal',
    props: {
        value: { type: Boolean, default: false },
        userInfo: { type: Object, required: true },
        existingCoTutor: { type: Object, default: null },
        token: { type: String, default: null }
    },
    data() {
        return {
            loading: false,
            form: {
                firstName: '',
                lastName: '',
                rut: '',
                relationshipType: null,
                file: null
            },
            relationshipOptions: RELATIONSHIP_TYPE_OPTIONS
        };
    },
    computed: {
        show: {
            get() { return this.value; },
            set(val) { this.$emit('input', val); }
        }
    },
    watch: {
        value(val) {
            if (val && this.existingCoTutor) {
                this.form.firstName = this.existingCoTutor.firstName || '';
                this.form.lastName = this.existingCoTutor.lastName || '';
                this.form.rut = this.existingCoTutor.rut || '';
                this.form.relationshipType = this.existingCoTutor.relationshipType || null;
                this.form.file = null;
            } else if (val) {
                this.resetForm();
            }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                firstName: '',
                lastName: '',
                rut: '',
                relationshipType: null,
                file: null
            };
            if (this.$refs.form) this.$refs.form.resetValidation();
        },
        close() {
            this.resetForm();
            this.show = false;
        },
        async save() {
            if (!this.$refs.form.validate()) return;
            this.loading = true;
            try {
                let file = null;
                if (this.form.file) {
                    const base64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = reject;
                        reader.readAsDataURL(this.form.file);
                    });
                    file = {
                        base64,
                        contentType: this.form.file.type,
                        extension: this.form.file.name.split('.').pop()
                    };
                }
                const coTutorData = {
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    rut: this.form.rut || null,
                    relationshipType: this.form.relationshipType,
                    file
                };
                let result;
                if (this.existingCoTutor?.id) {
                    result = await Api360Service.updateCoTutor(
                        this.existingCoTutor.id,
                        coTutorData,
                        this.token
                    );
                } else {
                    result = await Api360Service.addCoTutor(
                        this.userInfo.userId,
                        coTutorData,
                        this.token
                    );
                }
                this.$emit('co-tutor-saved', result);
                this.close();
            } catch (e) {
                console.error('Error guardando co-tutor:', e);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.cotutor-modal {
    border-radius: 12px;
}
.modal-title {
    font-size: 1.1rem !important;
    font-weight: 600;
    color: #1b1d21;
    padding-bottom: 4px;
}
.field-wrapper {
    margin-bottom: 16px;
}
.field-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #0F5CB9;
    margin-bottom: 4px;
}
.optional {
    font-weight: 400;
    color: #6A7682;
}
.custom-input >>> .v-input__slot {
    border-radius: 8px !important;
    border-color: #CFD3D4 !important;
    font-size: 14px !important;
}
.custom-input >>> .v-input__slot fieldset {
    border-color: #CFD3D4 !important;
}
.custom-input >>> input::placeholder,
.custom-input >>> textarea::placeholder {
    color: #ABAFB1 !important;
    font-size: 14px;
}
.custom-input >>> .v-select__selection--comma {
    font-size: 14px;
}
.custom-input >>> .v-label {
    display: none;
}
</style>
